var _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWearableSmall = function SvgWearableSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 1.5,
    width: 6,
    height: 9,
    rx: 1,
    stroke: "#2196F3"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 3.5,
    width: 2,
    height: 2.75,
    rx: 0.5,
    stroke: "#2196F3"
  })));
};
export { SvgWearableSmall as ReactComponent };
export default "data:image/svg+xml,%3Csvg width='12' height='12' viewBox='0 0 12 12' fill='none' xmlns='http://www.w3.org/2000/svg'%3E %3Crect x='3' y='1.5' width='6' height='9' rx='1' stroke='%232196F3'/%3E %3Crect x='5' y='3.5' width='2' height='2.75' rx='0.5' stroke='%232196F3'/%3E %3C/svg%3E";